import { Tag } from '@lyearn/icons';
import getIconSettingsComponents from '@/components/IconSettings';
import { IconSettings, TagSettingsType } from '@/types/schema';

const [TagIcon, ListItemTagIcon] = getIconSettingsComponents(Tag);

function getTagIcon(
  tag?: { settings: Pick<TagSettingsType, 'iconSettings'> } | null,
  size: number | undefined = 20,
) {
  if (!tag) {
    return null;
  }

  return <TagIcon iconSettings={tag.settings.iconSettings} size={size} />;
}

export const getListItemTagIcon = (
  iconSettings: IconSettings,
  className?: string,
  iconSize?: number,
) => <ListItemTagIcon className={className} iconSettings={iconSettings} size={iconSize} />;

export default getTagIcon;
export { TagIcon };
